import { render, staticRenderFns } from "./BlockDocument.vue?vue&type=template&id=ea0434b4"
import script from "./BlockDocument.vue?vue&type=script&lang=js"
export * from "./BlockDocument.vue?vue&type=script&lang=js"
import style0 from "./BlockDocument.vue?vue&type=style&index=0&id=ea0434b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports